import * as React from 'react';

type TChatListLayoutProps = {
  topMenu: React.ReactNode;
  chatListContent: React.ReactNode;
  listActionButtons?: React.ReactNode;
  contextMenu?: React.ReactNode;
};

export const ChatListLayout: React.FC<TChatListLayoutProps> = React.memo(
  ({ topMenu, chatListContent, listActionButtons, contextMenu }) => {
    return (
      <>
        {topMenu}
        {chatListContent}
        {listActionButtons}
        {contextMenu}
      </>
    );
  },
);

ChatListLayout.displayName = 'ChatListLayout';
